import createSelector from 'web-app/util/custom-create-selector';
import RoutesMap from 'signin-app/routes/routes-map';
import { employeeEstimatedCheckoutTimeEnabled } from 'signin-app/groups/selectors';
import { isPinApp } from 'signin-app/login/selectors';
import * as GroupSelectors from 'signin-app/groups/selectors';
import * as GroupHelpers from 'signin-app/groups/helpers';
import { makeStaffSelector, getPinEmployee } from '../selectors';
export const selectedHours = (state) => state.employeeCheckIn.selectedLeaveHours;
export const selectedMinutes = (state) => state.employeeCheckIn.selectedLeaveMinutes;
export const isCheckingIn = (state) => state.employeeCheckIn.isCheckingIn;
export const selectedGroupId = (state) => state.employeeCheckIn.selectedGroupId;
const entityStaffSelector = makeStaffSelector(RoutesMap.employeeCheckIn);
export const employee = createSelector(isPinApp, getPinEmployee, entityStaffSelector, (pinApp, pinEmployee, entityStaff) => {
    if (pinApp) {
        return pinEmployee;
    }
    return entityStaff;
});
export const canCheckIn = createSelector(selectedHours, selectedMinutes, selectedGroupId, employeeEstimatedCheckoutTimeEnabled, (hours, minutes, groupId, checkoutTimeEnabled) => {
    if (checkoutTimeEnabled) {
        return hours !== undefined && minutes !== undefined && groupId.length > 0;
    }
    return true;
});
// Employees can select a time outside the opening hours
// between 9:00 - 23:45
const HOURS_START = 9;
const HOURS_END = 23;
export const staffTimeOptionsBase = Array.from(Array(HOURS_END - HOURS_START + 1)).reduce((acc, _, i) => {
    return acc.concat({
        hour: HOURS_START + i,
        minutes: [0, 15, 30, 45],
    });
}, []);
export const checkoutTimeOptions = createSelector(GroupSelectors.timezone, timezone => {
    return GroupHelpers.timesLaterThanNow(staffTimeOptionsBase, timezone);
});
